module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Laporan")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Laporan")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  }, [_vm._v("Tambah Data")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData6,
      "span-method": _vm.objectSpanMethod1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.id !== '') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-caret-bottom"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.name !== '') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-caret-bottom"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount1",
      "label": "Amount 1"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount2",
      "label": "Amount 2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount3",
      "label": "Amount 3"
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c3667cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/LaporanCoba.vue
// module id = 1392
// module chunks = 2